import { render, staticRenderFns } from "./AdminControlTableItem.vue?vue&type=template&id=09410f3a&"
import script from "./AdminControlTableItem.vue?vue&type=script&lang=ts&"
export * from "./AdminControlTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports